var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable camelcase */
import { singleControlledAction } from 'src/types';
import constructLocalEntity from 'src/utils/vuexModuleConstructor/constructLocalEntity';
import localEntityListInMenuItem from 'src/utils/mainMenuOperations/localEntityListInMenuItem';
import { id, row_menu, userColumn } from 'src/utils/entityOperations/columns/basicColumns';
import getRecords from 'src/utils/entityOperations/getRecords';
import createRecords from 'src/utils/entityOperations/createRecords';
import { getActingUser } from 'src/utils/actingUser';
import { cloneDeep, get, set } from 'lodash';
import deepmerge from 'deepmerge';
const controlledActions = singleControlledAction(876);
const columns = () => {
    return [
        row_menu({ menuItemShortcuts: ['del', 'copy'] }),
        id(),
        userColumn(),
        { name: 'value_object', label: 'Value Object', hideWhenDisplayingInNonTable: true },
    ];
};
const remoteEntityName = 'preferences.user_preferences';
const localEntityName = remoteEntityName;
const localEntity = constructLocalEntity({
    columns,
    entityLabel: 'User Preference',
    entityLabelPlural: 'User Preferences',
    remoteEntityName,
    apiVersion: 1,
    controlledActions,
    pageTitle: 'User Preferences',
});
export default localEntity;
export const userPreferences__menuItem = (params) => (Object.assign(Object.assign({ label: 'User Preferences', icon: { name: 'mdi-keyboard-outline' }, prefetch: true }, localEntityListInMenuItem({
    localEntityNameProp: localEntityName,
    tableIdProp: localEntityName,
})), params));
/**
 * Retrieves user preferences for the current user within a specified namespace.
 * @param namespace The namespace of the preferences (e.g., 'platform', 'app32').
 * @returns The preferences object for the given namespace.
 */
export function getUserPreferencesForCurrentUser(namespace) {
    var _a;
    const records = getRecords(localEntityName);
    const record = records.find((r) => r.user_id === getActingUser().id);
    const value_object = ((_a = record === null || record === void 0 ? void 0 : record.value_object) === null || _a === void 0 ? void 0 : _a[namespace]) || {};
    return value_object;
}
/**
 * Sets user preferences for the current user within a specified namespace.
 * @param namespace The namespace of the preferences.
 * @param value_object The preferences object to set.
 */
export function setUserPreferencesForCurrentUser(namespace, value_object) {
    return __awaiter(this, void 0, void 0, function* () {
        const records = getRecords(localEntityName);
        const existingRecord = records.find((r) => r.user_id === getActingUser().id);
        const currentValueObject = (existingRecord === null || existingRecord === void 0 ? void 0 : existingRecord.value_object) || {};
        const mergedValueObject = Object.assign(Object.assign({}, currentValueObject), { [namespace]: deepmerge(currentValueObject[namespace] || {}, value_object) });
        const newRecord = {
            id: (existingRecord === null || existingRecord === void 0 ? void 0 : existingRecord.id) || -1,
            user_id: getActingUser().id,
            value_object: mergedValueObject,
        };
        const response = yield createRecords(localEntityName, [newRecord]);
        if (response.result === 'success') {
            console.log('User preferences set successfully:', response);
        }
        else {
            console.error('Failed to set user preferences:', response);
        }
        return response;
    });
}
/**
 * Updates a specific preference value for the current user within a specified namespace.
 * @param params An object containing the namespace, preference key path, and new value.
 */
export function updateUserPreferencesForCurrentUser(params) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        const { namespace, preferenceKeyPath, preferenceValue } = params;
        const userPreferences = getUserPreferencesForCurrentUser(namespace);
        const value_object = cloneDeep(userPreferences);
        set(value_object, preferenceKeyPath, preferenceValue);
        const response = yield setUserPreferencesForCurrentUser(namespace, value_object);
        if (response.result === 'success') {
            const data = (_a = response.data) === null || _a === void 0 ? void 0 : _a[0];
            const newValue = get(data.value_object, preferenceKeyPath);
            return newValue;
        }
        else {
            debugger;
            throw new Error('Failed to update user preferences');
        }
    });
}
